<template>
  <main class="container">
    <h1 class="page-container-title">{{ adminText('organizationAll.members_list_28f4dfe4', 'Members List') }}</h1>
    <spinner v-if="loading" />
    <template v-else>
      <section class="mb-32 active-membership-plans">
        <h2 class="page-container-subtitle">{{ adminText('organizationAll.active_a733b809', 'Active') }}</h2>

        <p v-if="!activeMembershipPlans.length" class="no-items-message">
          {{ adminText('organizationAll.no_active_membership_plans_20143887', 'No active membership plans.') }}
        </p>

        <div v-else class="items-container">
          <article v-for="plan in activeMembershipPlans" :key="plan.id" class="item-card">
            <a
              :href="`/sport-organizations/${organizationSlug}/members-list/${plan.id}?membershipPlanName=${plan.name}`"
              class="item-link"
            >
              <p class="item-title">{{ plan.name }}</p>
              <p class="item-date">{{ formatDate(plan.from) }} - {{ formatDate(plan.to) }}</p>
            </a>
          </article>
        </div>
      </section>
      <section>
        <h2 class="page-container-subtitle">{{ adminText('organizationAll.past_405c12fb', 'Past') }}</h2>
        <p v-if="!pastMembershipPlans.length" class="no-items-message">{{ adminText('organizationAll.no_past_membership_plans_0a03be80', 'No past membership plans.') }}</p>
        <div v-else class="items-container">
          <article v-for="plan in pastMembershipPlans" :key="plan.id" class="item-card">
            <a
              :href="`/sport-organizations/${organizationSlug}/members-list/${plan.id}?membershipPlanName=${plan.name}`"
              class="item-link"
            >
              <p class="item-title">{{ plan.name }}</p>
              <p class="item-date">{{ formatDate(plan.from) }} - {{ formatDate(plan.to) }}</p>
            </a>
          </article>
        </div>
      </section>
    </template>
  </main>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { GET_SPORT_ORGANIZATION_MEMBERSHIP_PLANS } from '@/graphql/membershipPlan.graphql'
import spinner from '../../shared/spinner.vue'
import moment from 'moment'

export default {
  mixins: [OrganizationLocalization],
  name: 'sport-memberships-list-overview',
  components: {
    spinner,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      activeMembershipPlans: [],
      pastMembershipPlans: [],
      loading: true,
    }
  },
  async mounted() {
    await this.fetchMembershipPlans()
  },
  methods: {
    async fetchMembershipPlans() {
      const { data, errors } = await this.$apollo.query({
        query: GET_SPORT_ORGANIZATION_MEMBERSHIP_PLANS,
        variables: {
          organizationSlug: this.organizationSlug,
        },
      })
      if (!errors && data && data.getOrganizationMembershipPlans) {
        this.activeMembershipPlans = data.getOrganizationMembershipPlans.filter(plan =>
          moment(plan.to).isAfter(moment()),
        )
        this.pastMembershipPlans = data.getOrganizationMembershipPlans.filter(plan =>
          moment(plan.to).isBefore(moment()),
        )
      }
      this.loading = false
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY.')
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}
.page-container-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.page-container-subtitle {
  color: #ff4c00;
  font-size: 20px;
  font-family: Raleway;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 0.75rem;
}

.items-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 1150px) {
  .items-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

.no-items-message {
  color: #666666;
  font-size: 18px;
  font-family: Source Sans Pro;
  font-weight: 400;
  line-height: 27px;
  word-wrap: break-word;
}

.item-card {
  background-color: #f5f5f5;
  border-radius: 1.5rem;
}

.item-title {
  margin: 0;
  color: #666666;
  font-size: 24px;
  font-family: Raleway;
  font-weight: 600;
  line-height: 28.8px;
  word-wrap: break-word;
}

.active-membership-plans .item-title {
  color: #0277bd;
}

.item-date {
  margin: 0;
  color: #666666;
  font-size: 18px;
  font-family: Source Sans Pro;
  font-weight: 400;
  line-height: 27px;
  word-wrap: break-word;
}

.item-link {
  display: block;
  padding: 1rem;
  text-decoration: none;
  color: inherit;
  padding: 2rem;
}
</style>
